const authorityAlls = {
	ADVERTISING_READ: "ADVERTISING_READ",
	ADVERTISING_WRITE: "ADVERTISING_WRITE",
	ADVERTISING_APPROVAL_READ: "ADVERTISING_APPROVAL_READ",
	ADVERTISING_APPROVAL_WRITE: "ADVERTISING_APPROVAL_WRITE",
	ANALYZER_READ: "ANALYZER_READ",
	ANALYZER_WRITE: "ANALYZER_WRITE",
	GOODS_CATEGORY_PROFESSIONAL_READ: "GOODS_CATEGORY_PROFESSIONAL_READ",
	GOODS_CATEGORY_PROFESSIONAL_WRITE: "GOODS_CATEGORY_PROFESSIONAL_WRITE",
	GOODS_CATEGORY_RETAIL_READ: "GOODS_CATEGORY_RETAIL_READ",
	GOODS_CATEGORY_RETAIL_WRITE: "GOODS_CATEGORY_RETAIL_WRITE",
	GOODS_READ: "GOODS_READ",
	GOODS_WRITE: "GOODS_WRITE",
	GOODS_PROFESSIONAL_WRITE: "GOODS_PROFESSIONAL_WRITE",
	GOODS_PROFESSIONAL_READ: "GOODS_PROFESSIONAL_READ",
	HEALTHY_HAIR_READ: "HEALTHY_HAIR_READ",
	HEALTHY_HAIR_WRITE: "HEALTHY_HAIR_WRITE",
	HEALTHY_HAIR_PROFESSIONAL_WRITE: "HEALTHY_HAIR_PROFESSIONAL_WRITE",
	HEALTHY_HAIR_PROFESSIONAL_READ: "HEALTHY_HAIR_PROFESSIONAL_READ",
	TAG_READ: "TAG_READ",
	TAG_WRITE: "TAG_WRITE",
	TAG_PROFESSIONAL_WRITE: "TAG_PROFESSIONAL_WRITE",
	TAG_PROFESSIONAL_READ: "TAG_PROFESSIONAL_READ",
	USER_READ: "USER_READ",
	USER_WRITE: "USER_WRITE",
	PERSONAL_USER_WRITE: "PERSONAL_USER_WRITE",
	ROLE_READ: "ROLE_READ",
	ROLE_WRITE: "ROLE_WRITE",
	AUTHORITY_READ: "AUTHORITY_READ",
	AUTHORITY_WRITE: "AUTHORITY_WRITE",
	ANALYZER_PROFESSIONAL_READ: "ANALYZER_PROFESSIONAL_READ",
	ANALYZER_PROFESSIONAL_WRITE: "ANALYZER_PROFESSIONAL_WRITE",
	ADVERTISING_APPROVAL_PROFESSIONAL_READ: "ADVERTISING_APPROVAL_PROFESSIONAL_READ",
	ADVERTISING_APPROVAL_PROFESSIONAL_WRITE: "ADVERTISING_APPROVAL_PROFESSIONAL_WRITE",
	ADVERTISING_PROFESSIONAL_WRITE: "ADVERTISING_PROFESSIONAL_WRITE",
	ADVERTISING_PROFESSIONAL_READ: "ADVERTISING_PROFESSIONAL_READ",
	CUSTOMERS_PROFESSIONAL_WRITE: "CUSTOMERS_PROFESSIONAL_WRITE",
	CUSTOMERS_PROFESSIONAL_READ: "CUSTOMERS_PROFESSIONAL_READ",
};
export default authorityAlls;
